import React from 'react'
import Container from '@material-ui/core/Container'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
    footer: {
        color: theme.palette.black.main,
        backgroundColor: '#FFFFFF',
        borderTop: '1px solid #D1D1D1',
        fontSize: '1rem',
        zIndex: 1,
    },
    footerContentContainer: {
        margin: '0 auto',
        padding: '1.25rem 0',
        [theme.breakpoints.up('md')]: {
            width: '66%',
        },
    },
}))

const Footer = ({ content }) => {
    const classes = useStyles()
    return (
        <footer className={classes.footer}>
            <div className={classes.footerContentContainer}>
                <Container maxWidth="lg">{content}</Container>
            </div>
        </footer>
    )
}

export default Footer
